import makeApiCall from "../master/axiosIndex";

const invoiceApis = {
  submitInvoice: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/submitInvoice",
      method: "post",
      data: data,
    }),
  fetchAllInvoices: (): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchAllInvoices",
      method: "get",
    }),
  fetchAllInvoicesByOrderAndOrderLineNo: (
    orderId: any,
    orderLineId: any
  ): Promise<any> =>
    makeApiCall<any>({
      url: `/billing/fetchAllInvoicesByOrderAndOrderLineNo?orderNumber=${orderId}&orderLineNo=${orderLineId}`,
      method: "get",
    }),
  fetchInvoice: (id: string): Promise<any> =>
    makeApiCall<any>({
      url: `/billing/fetchInvoice?invoiceNumber=${id}`,
      method: "get",
    }),
  fetchPayableInvoicesForPayments: (): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchPayableInvoicesForPayments",
      method: "get",
    }),
  fetchAllPaidInvoices: (): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchAllPaidInvoices",
      method: "get",
    }),
  fetchAllInvoicesForCreditDebitNote: (orgOrSupplierId: any): Promise<any> =>
    makeApiCall<any>({
      url: `/billing/fetchAllInvoicesForCreditDebitNote?orgOrSupplierId=${orgOrSupplierId}`,
      method: "get",
    }),
  fetchAllInvoicesWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchAllInvoicesWithPagination",
      method: "get",
      params,
    }),
  bulkUploadInvoiceMaterials: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/invoiceMaterialBulkUpload",
      method: "post",
      data: data,
    }),
  createReturn: (data: FormData): Promise<any> =>
    makeApiCall<any>({
      url: "/return/create",
      method: "post",
      data: data,
    }),
  fetchWidgetCount: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/billing/fetchPurchaseToPayInvociesWidgetCounts",
    }),
  fetchGateEntriesDropDownBySiteId: (siteId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchGateEntriesDropDownBySiteId?id=${siteId}`,
    }),
};

export default invoiceApis;
